document.addEventListener('DOMContentLoaded', () => {
    // Say a dog has been entered into 2 NFC days
    // We want to stop the user from ticking 3 NFC checkboxes
    document.querySelectorAll('[data-nfc-dog-checkbox]').forEach(function(dog) {
        let dogId = dog.getAttribute('data-nfc-dog-id');
        let totalAllowed = parseInt(dog.getAttribute('data-nfc-total-allowed'));
        let selector = '[data-nfc-dog-id="' + dogId + '"]';

        checkTotals(dogId, totalAllowed, selector);

        dog.addEventListener('change', function(event) {
            checkTotals(dogId, totalAllowed, selector);
        });
    });

    // Stop a dog from being put in more classes
    document.querySelectorAll('[data-class-dog-checkbox]').forEach(function(dog) {
        let dogId = dog.getAttribute('data-class-dog-id');
        let totalAllowed = parseInt(dog.getAttribute('data-class-total-allowed'));
        let selector = '[data-class-dog-id="' + dogId + '"]';

        checkTotals(dogId, totalAllowed, selector);

        dog.addEventListener('change', function(event) {
            checkTotals(dogId, totalAllowed, selector);
        });
    });
});

function checkTotals(dogId, totalAllowed, selector) {
    let totalChecked = document.querySelectorAll(selector + ':checked').length;

    if (totalChecked < totalAllowed) {
        document.querySelectorAll(selector).forEach(function (checkbox) {
            checkbox.removeAttribute('disabled');
        });

        return;
    }

    document.querySelectorAll(selector + ':not(:checked)').forEach(function (checkbox) {
        checkbox.setAttribute('disabled', 'disabled');
    });
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/editClasses.js